import React, {useState} from "react";
import {connect} from "react-redux";

import DropDown2 from "../../../Generic/dropDown2";
import {AVAILABLE_PRICES} from "../../../../reducers/pricingPreset";
import {setPricingPresetApplyToPrice} from "../../../../actions/pricingPresets";


const ApplyToPriceSelect = (props) => {

  const {applyToPrice, setPricingPresetApplyToPrice} = props;

  const [opened, setOpened] = useState(false);

  const onSelect = (value) => {
    setPricingPresetApplyToPrice(value);
    setOpened(false);
  }

  const allPrices = Object.values(AVAILABLE_PRICES).map(step => ({text: step, value: step}));

  return (
    <div className="wizard-popup__block-input">
      <div className={"fc-inst__select select2" + (opened ? " select2--active" : "")}>
        <div className="select2-value" onClick={() => setOpened(true)}>
          Apply To Price: <strong>{applyToPrice}</strong>
        </div>
        {opened ? (
          <DropDown2 selected={applyToPrice}
                     items={allPrices}
                     onClickOutside={() => setOpened(false)}
                     onSelect={onSelect}
                     useVirtualizedList={false}
                     filter={false}/>
        ) : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {applyToPrice} = store.pricingPreset;
  return {
    applyToPrice,
  };
};

const mapDispatchToProps = {
  setPricingPresetApplyToPrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplyToPriceSelect)
